module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_28-d6056b6c9177be9aae03ea40530c598f.png";